import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-field-search-bar',
  templateUrl: './field-search-bar.component.html',
  styleUrls: ['./field-search-bar.component.scss']
})
export class FieldSearchBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-module/components/field-search-bar/field-search-bar.component.ts